<template>
  <div
    class="d-flex flex-column align-center px-4 pt-12 pb-9"
    @click="editAvatar"
  >
    <div class="position-relative avatar-container">
      <base-avatar
        class="white--text"
        color="#00897B"
        :data="model"
        field="avatar"
        size="100"
      ></base-avatar>
      <div class="btn-add-avatar">
        <v-btn color="primary" depressed fab small @click="editAvatar">
          <v-icon large>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="pt-3">
      <div class="text-center text-caption" style="color:#757575">
        Dung lượng tối đa là 1MB.
        <br />
        Chỉ hỗ trợ: PNG, JPEG, JPG
      </div>
    </div>
    <avatar-picker
      :dialog="avaModal"
      :user="currentUser"
      @close="close"
      @input="changeFile"
    />
  </div>
</template>

<script>
import AvatarPicker from './avatar-dialog.vue'
import { mapGetters } from 'vuex'
import JsonToFormData from '@/src/utils/JsonToFormData'
export default {
  components: { AvatarPicker },
  props: {},
  data: () => ({
    avaModal: false,
    model: {},
  }),
  mounted() {
    this.drawer = false
    this.initdata()
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
  },
  methods: {
    initdata() {
      const {
        name,
        last_name,
        birthday,
        gender,
        avatar_url,
        mobile,
      } = this.currentUser
      this.model = {
        name,
        last_name,
        birthday,
        gender,
        avatar: avatar_url,
        mobile,
      }
    },
    async changeFile(file) {
      this.model.avatar = file
      let data = { ...this.model }
      if (
        this.model.avatar &&
        this.model.avatar.includes('data:image/png;base64')
      ) {
        data.avatar_base64 = this.model.avatar
        delete data.avatar
      }
      const res = await this.$store.dispatch(
        'auth/update',
        JsonToFormData(data)
      )
      if (res.data) {
        this.$store.commit(
          'auth/setUser',
          Object.assign(this.currentUser, res.data.data.data)
        )
        this.initdata()
      }
    },
    editAvatar() {
      this.avaModal = true
    },
    close() {
      this.avaModal = false
    },
  },
}
</script>

<style scoped>
.avatar-container {
  position: relative;
  border-radius: 50%;
  background-color: #dfddde;
  padding: 4px;
}
.btn-add-avatar {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 3px;
  border-radius: 50%;
  background-color: #fff;
}
</style>
